(function () {
  function getProductJSON(sectionId) {
    var el = document.getElementById('ProductJson-' + sectionId);
    if (!el) return null;
    try {
      return JSON.parse(el.textContent || el.innerText || '{}');
    } catch (e) {
      console.warn('Failed to parse Product JSON', e);
      return null;
    }
  }

  function findVariantById(product, id) {
    id = Number(id);
    if (!product || !Array.isArray(product.variants)) return null;
    return product.variants.find(function (v) { return v.id === id; }) || null;
  }

  function formatMoney(cents) {
    try {
      if (window.Shopify && typeof Shopify.formatMoney === 'function') {
        // Use the shop's money format string (e.g., "R$ {{amount}}")
        const format = window.Shopify.money_format || window.Shopify.theme && window.Shopify.theme.moneyFormat;
        return Shopify.formatMoney(cents, format);
      }
    } catch (e) {}
    // Fallback: assume cents integer, format basic
    const value = (cents / 100).toFixed(2);
    return `R$ ${value.replace('.', ',')}`;
  }

  function updatePriceUI(variant) {
    var priceWrap = document.querySelector('.product__price');
    if (!priceWrap || !variant) return;
    var regularEl = priceWrap.querySelector('.price-item--regular');
    var compareEl = priceWrap.querySelector('.compare_at_price');
    var discountWrap = priceWrap.querySelector('.product__dicount');

    if (regularEl) regularEl.textContent = formatMoney(variant.price);

    if (compareEl) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        compareEl.textContent = formatMoney(variant.compare_at_price);
        compareEl.style.display = '';
      } else {
        compareEl.style.display = 'none';
      }
    }

    // Update discount flag content if present
    if (discountWrap) {
      var hasCompare = Number(variant.compare_at_price) > Number(variant.price);
      if (hasCompare) {
        var raw = (1 - (Number(variant.price) / Number(variant.compare_at_price))) * 100;
        var pct = Math.round(raw);
        if (pct > 0) {
          discountWrap.style.display = '';
          var flagEl = discountWrap.querySelector('.akag-flagOff');
          if (flagEl) {
            flagEl.textContent = pct + '% Off';
          } else {
            discountWrap.textContent = '-' + pct + '%';
          }
        } else {
          discountWrap.style.display = 'none';
        }
      } else {
        discountWrap.style.display = 'none';
      }
    }

    var buyBox = document.querySelector('.product_buy-buttom');
    var buyBtn = buyBox ? buyBox.querySelector('.buy-button') : null;

    if (buyBox && buyBtn) {
      buyBtn.style.display = '';

      if (variant.available) {
        buyBox.classList.remove('disabled');
        buyBtn.disabled = false;
        buyBtn.textContent = 'ADICIONAR AO CARRINHO';
      } else {
        buyBox.classList.add('disabled');
        buyBtn.disabled = true;
        buyBtn.textContent = 'ESGOTADO';
      }
    }

    var stoqBox = document.getElementById('stoq-back-in-stock');

    if (variant.available) {
      if (buyBox) buyBox.classList.remove('is-out-of-stock');

      if (buyBtn) {
        buyBtn.style.display = '';
        buyBtn.disabled = false;
        buyBtn.textContent = 'ADICIONAR AO CARRINHO';
      }

      if (stoqBox) stoqBox.style.display = 'none';

    } else {
      if (buyBox) buyBox.classList.add('is-out-of-stock');

      if (buyBtn) {
        buyBtn.disabled = true;
      }

      if (stoqBox) stoqBox.style.display = 'block';
    }
  }

  function updateUrl(variantId) {
    if (!variantId) return;
    var url = new URL(window.location.href);
    url.searchParams.set('variant', String(variantId));
    history.replaceState(null, '', url.toString());
  }

  function initStoqObserver() {
    const target = document.getElementById('stoq-back-in-stock');
    if (!target) return;

    const observer = new MutationObserver(() => {
      const stoqBtn = document.querySelector('.restock-rocket-button-container');

      if (stoqBtn && !target.contains(stoqBtn)) {
        target.innerHTML = '';
        target.appendChild(stoqBtn);
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  function onVariantSelected(product, variant) {
    if (!variant) return;
    updatePriceUI(variant);
    updateUrl(variant.id);
    // Trigger custom event in case other scripts want to react
    var ev = new CustomEvent('akag:variant:change', { detail: { product: product, variant: variant } });
    document.dispatchEvent(ev);
  }

  function wireVariantSelectors(product) {
    // 1) Standard select[name="id"]
    var select = document.querySelector('select[name="id"]');
    if (select) {
      select.addEventListener('change', function (e) {
        var vid = e.target.value;
        var variant = findVariantById(product, vid);
        onVariantSelected(product, variant);
      });
    }

    // 2) Any element with data-variant-id (click)
    var clickable = document.querySelectorAll('[data-variant-id]');
    clickable.forEach(function (el) {
      el.addEventListener('click', function () {
        var vid = el.getAttribute('data-variant-id');
        var variant = findVariantById(product, vid);
        onVariantSelected(product, variant);
      });
    });

    // 3) Inputs (radio) with value = variant id, including size name="Tamanho"
    var radios = document.querySelectorAll('input[type="radio"][name="variant"], input[type="radio"][name="id"], input[type="radio"][name="Tamanho"], input[type="radio"][name="Cor"]');
    radios.forEach(function (el) {
      el.addEventListener('change', function () {
        var vid = el.value;
        var variant = findVariantById(product, vid);
        onVariantSelected(product, variant);
      });
    });

    document.querySelectorAll('.product-single__variant-list').forEach(function (list) {
      list.addEventListener('click', function (e) {
        var target = e.target;
        // If clicking on label/span/li, try to find the input inside
        var container = target.closest('.product-single__variant-item, label, li');
        if (container) {
          var input = container.querySelector('input[type="radio"]');
          if (input) {
            if (!input.checked) {
              input.checked = true;
              var vid = input.value;
              var variant = findVariantById(product, vid);
              onVariantSelected(product, variant);
            }
          }
        }
      });
    });
  }

  function init() {
    initStoqObserver();
    var sectionWrap = document.querySelector('[id^="ProductSection-"]');
    if (!sectionWrap) return;
    var sectionId = sectionWrap.getAttribute('data-section-id');
    var product = getProductJSON(sectionId);
    if (!product) return;

    // If URL has variant param, initialize to it
    var url = new URL(window.location.href);
    var variantParam = url.searchParams.get('variant');
    var initialVariant = null;
    if (variantParam) {
      initialVariant = findVariantById(product, variantParam);
    }
    if (!initialVariant) {
      // fallback to selected_or_first_available_variant approximation: first available
      initialVariant = product.variants.find(function (v) { return v.available; }) || product.variants[0];
    }

    if (initialVariant) {
      onVariantSelected(product, initialVariant);
    }

    wireVariantSelectors(product);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

document.addEventListener('variant:change', function(event) {
  const variant = event.detail.variant;
  const stoq = document.getElementById('stoq-back-in-stock');

  if (!stoq) return;

  if (variant.available) {
    stoq.style.display = 'none';
  } else {
    stoq.style.display = 'block';
  }
});

